import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'template',
  type: 'object',
  properties: {
    fromAddress: {
      type: 'string',
      title: 'E-mail nadawcy',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Pole musi być adresem e-mail.'
      }
    },
    name: {
      type: 'string',
      title: 'Nazwa szablonu',
      fieldRequired: true,
      maxLength: 500
    },
    subject: {
      type: 'string',
      title: 'Temat wiadomości',
      fieldRequired: true,
      maxLength: 500
    },
    fromName: {
      type: 'string',
      title: 'Nazwa nadawcy',
      fieldRequired: true,
      maxLength: 500
    },
    to: {
      type: 'string',
      title: 'Odbiorca',
      fieldRequired: false,
      maxLength: 500
    },
    body: {
      type: 'string',
      title: 'Treść *',
      fieldRequired: true
    }
  }
};
